// 클래스명 합치기
export function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}

// 날짜 포맷
export function formatDate(date, format = 'YYYY-MM-DD') {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');

  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes);
}

// 요일 구하기
export function getDayOfWeek(date) {
  const days = ['일', '월', '화', '수', '목', '금', '토'];
  return days[new Date(date).getDay()];
}

// 금액 포맷
export function formatCurrency(amount) {
  return new Intl.NumberFormat('ko-KR').format(amount);
}

// 전화번호 포맷
export function formatPhone(phone) {
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 11) {
    return cleaned.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  }
  if (cleaned.length === 10) {
    return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  }
  return phone;
}

// 사업자번호 포맷
export function formatBizNo(bizNo) {
  const cleaned = bizNo.replace(/\D/g, '');
  if (cleaned.length === 10) {
    return cleaned.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3');
  }
  return bizNo;
}

// 거리 계산 (Haversine formula)
export function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 6371; // 지구 반경 (km)
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;

  return Math.round(distance * 10) / 10; // 소수점 1자리
}

function toRad(deg) {
  return deg * (Math.PI / 180);
}

// 휴게시간 계산 (근로기준법)
export function calculateBreakTime(workMinutes) {
  if (workMinutes >= 480) return 60; // 8시간 이상: 60분
  if (workMinutes >= 240) return 30; // 4시간 이상: 30분
  return 0;
}

// 만 나이 계산
export function calculateAge(birthDate) {
  const today = new Date();
  const birth = new Date(birthDate);
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }

  return age;
}

// 임금 공제 계산
export function calculateDeductions(grossAmount) {
  // 고용보험: 0.9%
  const employmentInsurance = Math.round(grossAmount * 0.009);

  // 소득세 (일용근로자): 총급여의 6%에서 55% 공제
  // 일급 150,000원 초과분에 대해 2.7% (6% x 45%)
  const taxableAmount = Math.max(0, grossAmount - 150000);
  const incomeTax = Math.round(taxableAmount * 0.027);

  // 지방소득세: 소득세의 10%
  const localTax = Math.round(incomeTax * 0.1);

  const totalDeduction = employmentInsurance + incomeTax + localTax;
  const netAmount = grossAmount - totalDeduction;

  return {
    employmentInsurance,
    incomeTax,
    localTax,
    totalDeduction,
    netAmount,
  };
}

// API 응답 형식
export function apiResponse(data, meta = null) {
  const response = {
    success: true,
    data,
  };

  if (meta) {
    response.meta = meta;
  }

  return response;
}

// API 에러 응답
export function apiError(code, message, details = null) {
  const error = {
    success: false,
    error: {
      code,
      message,
    },
  };

  if (details) {
    error.error.details = details;
  }

  return error;
}
